import { createContext, useState } from "react";
const AuthorisationContext = createContext({});
import { useMain } from "../state/userMainState";
import { useCheckAPI } from "../hooks/useCheckAPI";

export const AuthorisationProvider = ({ children }) => {
  const [authorisation, setAuthorisation] = useState({
    roles: {},
    loading: true,
  });
  const { isSuccess, data, isPending, isError, error } = useMain();

  // Success Function
  const successFunc = () => {
    const user = data?.data?.data?.data?.data?.user;
    if (!user) return;
    const roles = {
      allowfinances: user.allowfinances === "true",
      alloworders: user.alloworders === "true",
      allowreturns: user.allowreturns === "true",
      allowstaff: user.allowstaff === "true",
      allowcontracts: user.allowcontracts === "true",
      allowgeneralreports: user.allowgeneralreports === "true",
      allowfinancialreports: user.allowfinancialreports === "true",
      allowentitlement: user.allowentitlement === "true",
      allowcheckout: user.allowcheckout === "true",
      allowwardrobe: user.allowwardrobe === "true",
      staffAllBranches: user.staffAllBranches === "true",
      staffRequestCreate: user.staffRequestCreate === "true",
      staffRequestApprove: user.staffRequestApprove === "true",
      addressCreate: user.addressCreate === "true",
      addressEdit: user.addressEdit === "true",
      addressListCompany: user.addressListCompany === "true",
      addressListBranch: user.addressListBranch === "true",
      staffCreate: user.staffCreate === "true",
      staffEdit: user.staffEdit === "true",
      allowBulkOrder: user.allowBulkOrder === "true",
    };
    setAuthorisation({ roles: roles, loading: false });
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <AuthorisationContext.Provider value={{ authorisation, setAuthorisation }}>
      {children}
    </AuthorisationContext.Provider>
  );
};

export default AuthorisationContext;
